import { render, staticRenderFns } from "./fourItem.vue?vue&type=template&id=32695f67&scoped=true&"
import script from "./fourItem.vue?vue&type=script&lang=js&"
export * from "./fourItem.vue?vue&type=script&lang=js&"
import style0 from "./fourItem.vue?vue&type=style&index=0&id=32695f67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32695f67",
  null
  
)

export default component.exports